import {
  Text,
  Box,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';

import { IconAlertCircle } from '../../../../../styles/icons';

import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import AboutMeForm from '../common-forms/AboutMeForm';

const EditSectionAbout = ({ profile }) => {
  // Render
  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            //width="100%"
            textAlign="left"
          >
            <Box>
              <Text>About me</Text>
              {profile.aboutMe && profile.aboutMe !== '' && (
                <Text textStyle="footer2" color="brand.200" noOfLines={1} maxWidth="300px">
                  {profile.aboutMe}
                </Text>
              )}
              {profile.therapistTitles.length > 0 && (
                <Text textStyle="footer2" color="brand.200">
                  Titles: {profile.therapistTitles.map((elem) => elem.label).join(' | ')}
                </Text>
              )}
              {profile.summary && profile.summary !== '' && (
                <Text textStyle="footer2" color="brand.200" noOfLines={1} maxWidth="300px">
                  Summary: {profile.summary}
                </Text>
              )}
              {profile.practiceStartDate && (
                <Text textStyle="footer2" color="brand.200">
                  Practice started: {new Date(profile.practiceStartDate).toLocaleDateString(
                    'en-GB',
                    {
                      year: 'numeric',
                      month: 'long',
                    }
                  )}
                </Text>
              )}
              {profile.gender.length > 0 && (
                <Text textStyle="footer2" color="brand.200">
                  Gender: {profile.gender.map((elem) => elem.label)[0]}
                </Text>
              )}
              {profile.languages.length > 0 && (
                <Text textStyle="footer2" color="brand.200">
                  Languages: {profile.languages.map((elem) => elem.label).join(' | ')}
                </Text>
              )}
            </Box>
            {profile.aboutMe?.length > 0
              && profile.therapistTitles.length > 0
              && profile.summary && profile.summary !== ''
              && profile.gender.length > 0
              && profile.languages.length > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Incomplete
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <AboutMeForm profile={profile} />
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionAbout;
